import { render, staticRenderFns } from "./ConfigurationPage.vue?vue&type=template&id=4488c0d0&scoped=true&"
import script from "./ConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationPage.vue?vue&type=style&index=0&id=4488c0d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4488c0d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4488c0d0')) {
      api.createRecord('4488c0d0', component.options)
    } else {
      api.reload('4488c0d0', component.options)
    }
    module.hot.accept("./ConfigurationPage.vue?vue&type=template&id=4488c0d0&scoped=true&", function () {
      api.rerender('4488c0d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/ConfigurationPage.vue"
export default component.exports